module.exports = __webpack_public_path__ + "img/fc897c9a974379ddc4ec47b4e49bc1a0.svg";